import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-book-seller-update-print-order',
  templateUrl: './book-seller-update-print-order.component.html',
  styleUrls: ['./book-seller-update-print-order.component.scss']
})
export class BookSellerUpdatePrintOrderComponent implements OnInit {

  id!: number;

  book_name = '';
  adesh_date: any = '';
  publish_date: any = '';

  totalprati = 0;
  totalpsankhya = 0;

  tempdata: any[] = [];

  constructor(
    private service: DigisubservicesService,
    private dialogRef: MatDialogRef<BookSellerUpdatePrintOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {

    this.id = this.data?.id;

    if (this.id) {
      this.loadOrder();
    }
  }

  loadOrder(): void {

    this.service.getPrintOrderById(this.id).subscribe({

      next: (res: any) => {

        if (res.success) {

          const header = res.data;

          this.book_name = header.book_name;
          this.adesh_date = header.adesh_date;
          this.publish_date = header.publish_date;
          this.totalpsankhya = header.ekun_prushth;

          this.tempdata = (res.items || []).map((x: any) => ({
            no: x.no,
            name: x.name,
            prati: Number(x.copies),
            shera: x.remarks
          }));

          this.calculateTotal();
        }
      },

      error: err => {
        console.error(err);
      }
    });
  }

  calculateTotal(): void {

    this.totalprati = this.tempdata.reduce(
      (sum, row) => sum + Number(row.prati || 0),
      0
    );
  }

  addRow(): void {

    this.tempdata.push({
      no: this.tempdata.length + 1,
      name: '',
      prati: 0,
      shera: ''
    });
  }

  removeRow(index: number): void {

    this.tempdata.splice(index, 1);

    this.tempdata.forEach((x, i) => {
      x.no = i + 1;
    });

    this.calculateTotal();
  }

  // updateOrder(): void {

  //   const payload = {

  //     id: this.id,

  //     book_name: this.book_name,

  //     adesh_date: this.adesh_date,

  //     publish_date: this.publish_date,

  //     ekun_prushth: this.totalpsankhya,

  //     items: this.tempdata.map(x => ({
  //       no: x.no,
  //       name: x.name,
  //       copies: x.prati,
  //       remarks: x.shera
  //     }))
  //   };

  //   console.log(payload);

  //   // API Call
  //   // this.service.updatePrintOrder(payload).subscribe(...)
  // }
  updateOrder(): void {
    debugger

  const payload = {
    id: this.id,
    book_name: this.book_name,
    adesh_date: this.adesh_date,
    ekun_prushth: this.totalpsankhya,

    items: this.tempdata.map((item: any) => ({
      name: item.name,
      copies: Number(item.prati),
      remarks: item.shera
    }))
  };

  console.log('Update Payload:', payload);

  this.service.updatePrintOrder(payload).subscribe({
    next: (res: any) => {

      if (res?.success) {
        alert('Updated Successfully');

        // optional: close dialog
        this.dialogRef.close(true);
      } else {
        alert('Update Failed');
      }

    },
    error: (err) => {
      console.error('Update API Error:', err);
      alert('Something went wrong');
    }
  });
}

  closeDialog(): void {
    this.dialogRef.close();
  }
}